import logoImage from './BTB_Logo_ohne_Text_512w.png';

const Logo = () => {
    return(
        <img id='logo' src={logoImage} alt='BTB Logo'/>
    )
}

export default Logo;